import { connect } from "react-redux";
import { Dispatch } from "redux";
import { handleAuth0Callback } from "../../actions";
import { AuthAction } from "../../actionTypes";
import RequiresAuth from "../presenters/RequiresAuth";

function mapStateToProps(rootState: any, ownProps: any) {
    return {
        auth: rootState.auth,
        ownProps,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AuthAction>) {
    return {
        onAuth0Callback: async () => handleAuth0Callback(dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequiresAuth);

/*

import { connect } from "react-redux";
// import { Dispatch } from 'redux';
// import { actionTypes } from 'src/auth';
// import * as actions from "../../actions";
import { IAuthState } from "../../model";
import RequiresAuth from "../presenters/RequiresAuth";

function mapStateToProps({ auth }: { auth: IAuthState} ) {
    return {
        auth,
    };
}

function mapDispatchToProps(dispatch: any) {
    return { ...dispatch };
}

function mapLocalToProps(rest: any) {
    return {...rest};
}

export default connect(mapStateToProps, mapDispatchToProps, mapLocalToProps)(RequiresAuth);

*/
